import { zodResolver } from "@hookform/resolvers/zod";
import { UpdateIcon } from "@radix-ui/react-icons";
import { XIcon } from "lucide-react";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { Button } from "./button";
import { Form, FormControl, FormField, FormItem, FormMessage } from "./form";
import { Input } from "./input";

const formSchema = z.object({
  title: z.string().min(1, "Titel ist erforderlich"),
});

type FormValues = z.infer<typeof formSchema>;

interface TitleFormProps {
  onSubmit: (values: FormValues) => void;
  onCancel: () => void;
  defaultValue?: string;
}

const TitleForm = ({ onSubmit, onCancel, defaultValue }: TitleFormProps) => {
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      title: defaultValue || "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-row gap-2 items-center">
        <FormField
          control={form.control}
          name="title"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input placeholder="Titel eingeben..." {...field} className="h-10" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div>
          <Button type="submit" className="gap-2">
            {defaultValue ? (
              <>
                <UpdateIcon className="h-4 w-4" /> Aktualisieren
              </>
            ) : (
              "Speichern"
            )}
          </Button>
          <Button size="icon" onClick={onCancel} variant="ghost">
            <XIcon className="h-4 w-4" />
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default TitleForm;
